import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FRONTEND_BASE_URL, notification } from "../../../../../utils/utility";
import OnboardingSetupLayout, {
  OnboardingActions,
} from "../../../../../components/OnboardingSetup/OnboardingSetupLayout";

const IconMail = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.7" />
    <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
  </svg>
);

const IconWhatsApp = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.04 2C6.58 2 2.15 6.4 2.15 11.83c0 1.74.46 3.44 1.34 4.94L2 22l5.4-1.4a10 10 0 004.64 1.17h.04c5.46 0 9.89-4.4 9.89-9.83C21.97 6.4 17.5 2 12.04 2zm5.74 14.17c-.24.68-1.4 1.25-1.94 1.33-.5.07-1.12.1-1.81-.11-.42-.13-.95-.31-1.64-.6-2.89-1.25-4.77-4.16-4.92-4.35-.14-.2-1.18-1.57-1.18-3 0-1.42.75-2.12 1.01-2.41.26-.29.57-.36.76-.36h.55c.17 0 .41-.07.64.49.24.58.82 2 .89 2.15.07.15.12.32.02.52-.1.2-.15.32-.3.5-.15.17-.31.39-.45.52-.15.15-.3.31-.13.6.17.29.77 1.27 1.66 2.06 1.14 1.01 2.1 1.33 2.4 1.48.29.15.46.12.63-.07.17-.2.74-.86.94-1.16.2-.29.4-.24.67-.15.26.1 1.68.79 1.97.94.29.14.48.21.55.33.07.12.07.68-.17 1.36z" />
  </svg>
);

const IconLinkedIn = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M6.5 9H3.8v11h2.7V9zM5.15 3.5A1.65 1.65 0 103.5 5.15 1.65 1.65 0 005.15 3.5zM20.2 20h-2.7v-5.35c0-1.27 0-2.9-1.77-2.9s-2.04 1.38-2.04 2.81V20H11v-11h2.58v1.5h.04a2.83 2.83 0 012.55-1.4c2.73 0 3.23 1.8 3.23 4.14z" />
  </svg>
);

const INVITE_LINK = `${FRONTEND_BASE_URL}signup`;

const ProfileStepFour = () => {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);

  const shareText = "Join me on MeetOcto — the easiest way to schedule meetings without the back-and-forth.";
  const encodedLink = encodeURIComponent(INVITE_LINK);
  const encodedText = encodeURIComponent(`${shareText} ${INVITE_LINK}`);

  const copyLink = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(INVITE_LINK);
      } else {
        const el = document.createElement("textarea");
        el.value = INVITE_LINK;
        el.style.position = "fixed";
        el.style.opacity = "0";
        document.body.appendChild(el);
        el.focus();
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
      }
      setCopied(true);
      notification.success("Invite link copied!");
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      notification.error("Could not copy the link. Please copy it manually.");
    }
  };

  const openEmail = () => {
    const subject = encodeURIComponent("You should check out MeetOcto");
    const body = encodeURIComponent(
      `Hi,\n\nI've been using MeetOcto to schedule meetings and it's great. Thought you might find it useful too!\n\nSign up here: ${INVITE_LINK}\n\nBest,`
    );
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };

  return (
    <OnboardingSetupLayout
      currentStep={4}
      title="Invite a colleague"
      description="Optional. Share MeetOcto with someone on your team."
    >
      <form
        className="onboarding-setup__form"
        onSubmit={(event) => {
          event.preventDefault();
          navigate("/signup/payment");
        }}
      >
        <div className="onboarding-setup__field">
          <label className="onboarding-setup__label" htmlFor="invite_link">
            Your invite link
          </label>
          <div className="onboarding-setup__invite">
            <p className="onboarding-setup__invite-url" id="invite_link">
              {INVITE_LINK}
            </p>
            <button
              type="button"
              className="onboarding-setup__invite-copy"
              onClick={copyLink}
            >
              {copied ? "Copied!" : "Copy"}
            </button>
          </div>
        </div>

        <div className="onboarding-setup__share" aria-label="Share via">
          <button
            type="button"
            className="onboarding-setup__share-btn"
            onClick={openEmail}
          >
            <IconMail /> Email
          </button>
          <a
            className="onboarding-setup__share-btn"
            href={`https://wa.me/?text=${encodedText}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconWhatsApp /> WhatsApp
          </a>
          <a
            className="onboarding-setup__share-btn"
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedLink}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconLinkedIn /> LinkedIn
          </a>
        </div>

        <OnboardingActions
          onBack={() => navigate("/signup/profile-step-three")}
          showSkip={false}
          submitLabel="Continue to plans"
        />
      </form>
    </OnboardingSetupLayout>
  );
};

export default ProfileStepFour;
